var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[(_vm.code == 401)?_c('img',{attrs:{"src":require("@imgs/401.png")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }